import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Util from "../../Classes/Utils";
import {
  GetCountriesWithCities,
  GetOrderAddressBookByAddressType,
} from "../Data";
import { Global } from "../Variables/Global";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import PhoneInput from "react-phone-number-input";
import { toast } from "react-toastify";
import Cookies from "js-cookie";

const Checkout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [key, setKey] = useState("Home");
  const [city, setCity] = useState("");
  const [cityId, setCityId] = useState("");
  const [cartItems, setCartItems] = useState(location.state?.cartItems);
  const [cartCount, setCartCount] = useState(location.state?.cartCount);
  const [total, setTotal] = useState(0);
  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [Email, setEmail] = useState("");
  const [Address1, setAddress1] = useState("");
  const [Address2, setAddress2] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [buttonClicked, setButtonClicked] = useState(false);
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState("");
  const [filteredCities, setFilteredCities] = useState([]);
  const [countryCode, setCountryCode] = useState("");
  const token = Cookies.get("CustomerToken");

  const getCountries = () => {
    GetCountriesWithCities(token).then((res) => {
      setCountries(res);
      getAddressBookDetailsHome(res);
    });
  };

  const getAddressBookDetailsHome = (res) => {
    const getItem = Cookies.get("Number") !== undefined;

    if (getItem) {
      var CustomerId = Cookies.get("Number");
      setAddress1("");
      setAddress2("");
      setEmail("");
      setLastName("");
      setFirstName("");
      setPhoneNumber("");
      setCity("");
      setCountry("");
      GetOrderAddressBookByAddressType(key, CustomerId, token)
        .then((Result) => {
          setAddress1(Result.Address1);
          setAddress2(Result.Address2);
          setFirstName(Result.FirstName);
          setLastName(Result.LastName);
          setPhoneNumber(Result.PhoneNumber);
          setEmail(Result.Email);
          setCountry(Result.State);
          const filteredCountries = res.filter((i) => i.CountryName === Result.State);
          setFilteredCities(filteredCountries[0].Cities);
          setCity(Result?.CityName);
          if (Result?.CityId) {
            fetch(
              Global.API_URL + "Country/GetCitiyNameById/" + Result.CityId,
              {
                method: "GET",
                headers: {
                  Accept: "application/json",
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                  "Access-Control-Allow-Origin": Global.API_URL,
                },
              }
            )
              .then((response) => {
                return response.json();
              })
              .then((Result) => {
                setCity(Result[0].CityName);
                const value = Result[0].CityId;
                setCityId(value);
                if (Result[0].CountryCode === "UAE") {
                  setCountry("United Arab Emirates");
                  const filteredCountries = res?.filter(
                    (i) => i.CountryName === "United Arab Emirates"
                  );
                  setFilteredCities(filteredCountries[0]?.Cities);
                } else if (Result[0].CountryCode === "LB") {
                  setCountry("Lebanon");
                  const filteredCountries = res?.filter(
                    (i) => i.CountryName === "Lebanon"
                  );
                  setFilteredCities(filteredCountries[0]?.Cities);
                }
              });
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    }
  };

  const getTotal = () => {
    var Sumtotal = 0;
    const arr = Array.from(cartItems);
    arr.forEach((element) => {
      if (element.SalePrice === 0) {
        Sumtotal += element.RegularPrice * element.Quantity;
      } else {
        Sumtotal += element.SalePrice * element.Quantity;
      }
    });
    return Sumtotal;
  };

  const handleCheckout = (e) => {
    e.preventDefault();
    setButtonClicked(true);

    const countryCode =
      country === "United Arab Emirates" ? "UAE" :
        country === "Lebanon" ? "LB" :
          null;

    var groupId;
    if (Cookies.get("WishList") !== undefined) {
      groupId = 4;
    } else {
      groupId = 3;
    }
    const offset = new Date().getTimezoneOffset();
    var CartId = Cookies.get("Cart");
    fetch(
      Global.API_URL +
        "Order/CreateOrder?" +
        new URLSearchParams({
          CartId: CartId,
          Currency: "AED",
          CustomerUsername: `${FirstName + " " + LastName}`,
          Email: Email,
          PhoneNumber: PhoneNumber,
          Address1: Address1,
          Address2: Address1,
          CityName: city,
          IsDefault: false,
          IsSamePerson: false,
          Offset: offset,
          GroupId: groupId,
          CountryName: country,
          CountryCode: countryCode,
          CountryId: 125,
          PostalCode: "00000",
          State: "Dubai",
          AddressType: key,
          Notes: "Note",
        }),
      {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          },
      }
    )
      .then((response) => {
        if (response.ok) {
          toast.success("Order Successfuly Compeleted");
          navigate("/");
          return response.json();
        }
      })
      .catch((error) => {
        setButtonClicked(false);
        toast.error("Something went wrong ");
      });
  };

  const FilterCountries = (e) => {
    const value = e.target.value;
    setCountry(value);
    const filteredCountries = countries.filter((i) => i.CountryName === value);
    // const filteredCountries = countries.filter((x) => {
    // 	return x.Cities.some((Cities) => Cities.CityName === value)
    // });
    setFilteredCities(filteredCountries[0].Cities);
  };

  useEffect(() => {
    if(Cookies.get("CustomerToken") === undefined){
      navigate("/Authentication");
    }
    // getDetailsAddressBook();
    getTotal(cartItems);
    getCountries();
  }, [key]);
  return (
    <>
      <div className="breadcrumb-area mb-5">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="breadcrumb-container HomeShop">
                <ul>
                  <li>
                    <a href="index.html">
                      <i className="fa fa-home"></i> Home
                    </a>
                  </li>
                  <li className="active">Checkout</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-section section mb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-md-12 col-12">
              <form className="checkout-form" onSubmit={handleCheckout}>
                <Tabs
                  activeKey={key}
                  id="controlled-tab-example"
                  className="mb-3"
                  onSelect={(k) => setKey(k)}
                >
                  <Tab eventKey="Home" title="Home">
                    <div className="row row-4">
                      <div className="col-lg-12 mb-2">
                        <div id="billing-form" className="mb-4">
                          <h4 className="checkout-title">Billing Address</h4>

                          <div className="row">
                            <div className="col-md-6 col-12 mb-2">
                              <label>First Name*</label>
                              <input
                                value={FirstName}
                                type="text"
                                placeholder="First Name"
                                onChange={(e) => setFirstName(e.target.value)}
                                required
                              />
                            </div>

                            <div className="col-md-6 col-12 mb-2">
                              <label>Last Name*</label>
                              <input
                                value={LastName}
                                type="text"
                                placeholder="Last Name"
                                onChange={(e) => setLastName(e.target.value)}
                                required
                              />
                            </div>

                            <div className="col-md-6 col-12 mb-2">
                              <label>Email Address*</label>
                              <input
                                value={Email}
                                type="email"
                                placeholder="Email Address"
                                onChange={(e) => setEmail(e.target.value)}
                                required
                              />
                            </div>

                            <div className="col-md-6 col-12 mb-2">
                              <label>Phone no*</label>
                              <PhoneInput
                                placeholder="Type here"
                                className="inputBox"
                                value={PhoneNumber}
                                onChange={setPhoneNumber}
                                required
                              />
                            </div>

                            <div className="col-12 mb-2">
                              <label>Country</label>
                              <select
                                name="country"
                                className="checkout-form input"
                                onChange={(e) => FilterCountries(e)}
                                value={country}
                                required
                              >
                                <option value="please select country">
                                  Please select country
                                </option>
                                {countries &&
                                  countries.map((i, index) => (
                                    <option key={index} value={i.CountryName}>
                                      {i.CountryName}
                                    </option>
                                  ))}
                              </select>
                            </div>

                            <div className="col-12 mb-2">
                              <label>City</label>

                              <select
                                name="City"
                                className="checkout-form input"
                                onChange={(e) => setCity(e.target.value)}
                                value={city}
                                required
                              >
                                <option value="please select city">
                                  Please select city
                                </option>
                                {filteredCities &&
                                  filteredCities.map((i, index) => (
                                    <option key={index} value={i.CityName}>
                                      {i.CityName}
                                    </option>
                                  ))}
                              </select>
                            </div>

                            <div className="col-12 mb-2">
                              <label>Address*</label>
                              <input
                                value={Address1}
                                type="text"
                                placeholder="Address line 1"
                                onChange={(e) => setAddress1(e.target.value)}
                                required
                              />
                              <input
                                value={Address2}
                                type="text"
                                placeholder="Address line 2"
                                onChange={(e) => setAddress2(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab>
                  <Tab eventKey="Work" title="Work">
                    <div className="row row-4">
                      <div className="col-lg-12 mb-2">
                        <div id="billing-form" className="mb-4">
                          <h4 className="checkout-title">Billing Address</h4>

                          <div className="row">
                            <div className="col-md-6 col-12 mb-2">
                              <label>First Name*</label>
                              <input
                                value={FirstName}
                                type="text"
                                placeholder="First Name"
                                onChange={(e) => setFirstName(e.target.value)}
                                required
                              />
                            </div>

                            <div className="col-md-6 col-12 mb-2">
                              <label>Last Name*</label>
                              <input
                                value={LastName}
                                type="text"
                                placeholder="Last Name"
                                onChange={(e) => setFirstName(e.target.value)}
                                required
                              />
                            </div>

                            <div className="col-md-6 col-12 mb-2">
                              <label>Email Address*</label>
                              <input
                                value={Email}
                                type="email"
                                placeholder="Email Address"
                                onChange={(e) => setEmail(e.target.value)}
                                required
                              />
                            </div>

                            <div className="col-md-6 col-12 mb-2">
                              <label>Phone no*</label>
                              <PhoneInput
                                placeholder="Type here"
                                className="inputBox"
                                value={PhoneNumber}
                                onChange={setPhoneNumber}
                                required
                              />
                            </div>

                            <div className="col-12 mb-2">
                              <label>Country</label>
                              <select
                                name="country"
                                className="checkout-form input"
                                onChange={(e) => FilterCountries(e)}
                                value={country}
                                required
                              >
                                <option value="please select country">
                                  Please select country
                                </option>
                                {countries &&
                                  countries.map((i, index) => (
                                    <option key={index} value={i.CountryName}>
                                      {i.CountryName}
                                    </option>
                                  ))}
                              </select>
                            </div>

                            <div className="col-12 mb-2">
                              <label>City</label>

                              <select
                                name="City"
                                className="checkout-form input"
                                onChange={(e) => setCity(e.target.value)}
                                value={city}
                                required
                              >
                                <option value="please select city">
                                  Please select city
                                </option>
                                {filteredCities &&
                                  filteredCities.map((i, index) => (
                                    <option key={index} value={i.CityName}>
                                      {i.CityName}
                                    </option>
                                  ))}
                              </select>
                            </div>

                            <div className="col-12 mb-2">
                              <label>Address*</label>
                              <input
                                value={Address1}
                                type="text"
                                placeholder="Address line 1"
                                onChange={(e) => setAddress1(e.target.value)}
                                required
                              />
                              <input
                                value={Address2}
                                type="text"
                                placeholder="Address line 2"
                                onChange={(e) => setAddress2(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* <div className="col-lg-5">
												<div className="row">

													<div className="col-12 mb-5">

														<h4 className="checkout-title">Cart Total</h4>

														<div className="checkout-cart-total">

															<h4>Product <span>Total</span></h4>

															<ul>
																<li>item X 01<span>$25.00</span></li>
																<li>item X 02 <span>$50.00</span></li>
																<li>item X 01 <span>$29.00</span></li>
																<li>discount X 01 <span>$10.00</span></li>
															</ul>

															<p>Sub Total <span>$104.00</span></p>
															<p>Shipping Fee <span>$00.00</span></p>

															<h4>Grand Total <span>$104.00</span></h4>

														</div>

													</div>
												</div>
											</div> */}
                    </div>
                  </Tab>
                </Tabs>
                <div className="row">
                  <div className="col-12">
                    <button
                      type="submit"
                      // onClick={() => ()}
                      disabled={buttonClicked}
                      className="register-button mt-0"
                    >
                      Checkout
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div className="col-lg-5">
              <div className="row">
                <div className="col-12 mb-5">
                  <h4 className="checkout-title">Cart Total</h4>

                  <div className="checkout-cart-total">
                    <h4>
                      Product <span>Total</span>
                    </h4>

                    <ul>
                      {cartItems.map((cart, index) => {
                        return (
                          <div key={index}>
                            <li>
                              {cart.ProductName} X {cart.Quantity}
                              <span>
                                AED &nbsp;
                                {cart.SalePrice === 0
                                  ? cart.RegularPrice * cart.Quantity
                                  : cart.SalePrice * cart.Quantity}
                              </span>
                            </li>
                          </div>
                        );
                      })}
                    </ul>

                    <p>
                      Sub Total <span>{getTotal(cartItems)}</span>
                    </p>
                    <p>
                      Delivery <span>AED 30</span>
                    </p>

                    <h4>
                      Total <span>AED {getTotal() + 30}</span>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Checkout;
